import type { Plugin } from 'vue'

const plugin: Plugin = {
  install(app) {
    app.use(createPinia())
    app.use(PiniaColada)
  },
}

export default plugin
